import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

export function getProductFormFieldSx({
  inputHeight = 48,
  inputRadius = 8,
  inputPaddingX = 1.5,
  inputPaddingY = "13px",
} = {}) {
  return (theme) => ({
    "& .MuiOutlinedInput-root": {
      bgcolor: theme.palette.background.paper,
      borderRadius: inputRadius,
      minHeight: inputHeight,
      transition: "border-color 150ms ease, box-shadow 150ms ease",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.default,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.border.strong,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
    },
    "& .MuiOutlinedInput-input": {
      color: theme.palette.text.primary,
      fontSize: 14,
      fontWeight: 400,
      lineHeight: "20px",
      px: inputPaddingX,
      py: inputPaddingY,
    },
    "& .MuiSelect-select": {
      alignItems: "center",
      display: "flex",
      minHeight: "20px",
    },
    "& .MuiFormHelperText-root": {
      fontSize: 12,
      lineHeight: "16px",
      mx: 0,
      mt: 0.75,
    },
    "& fieldset": {
      top: 0,
    },
    "& legend": {
      display: "none",
    },
  });
}

export default function ProductFormField({
  children,
  fieldSx,
  inputHeight,
  inputPaddingX,
  inputPaddingY,
  inputRadius,
  label,
  labelSx,
  name,
  required = false,
  reserveHelperSpace = false,
  sx,
  ...props
}) {
  const inputId = props.id || (name ? `product-field-${name}` : undefined);
  const wrapperSx = Array.isArray(sx)
    ? [{ minWidth: 0, minHeight: reserveHelperSpace ? 82 : undefined }, ...sx]
    : [{ minWidth: 0, minHeight: reserveHelperSpace ? 82 : undefined }, sx];
  const inputSx = getProductFormFieldSx({
    inputHeight,
    inputPaddingX,
    inputPaddingY,
    inputRadius,
  });
  const textFieldSx = Array.isArray(fieldSx) ? [inputSx, ...fieldSx] : [inputSx, fieldSx];

  return (
    <Box sx={wrapperSx}>
      {label ? (
        <Typography
          component="label"
          htmlFor={inputId}
          sx={[
            {
              color: "text.primary",
              display: "block",
              fontSize: 14,
              fontWeight: 500,
              lineHeight: "18px",
              mb: "7px",
            },
            labelSx,
          ]}
        >
          {label}
          {required ? " *" : ""}
        </Typography>
      ) : null}
      <TextField
        {...props}
        id={inputId}
        fullWidth
        name={name}
        required={required}
        sx={textFieldSx}
      >
        {children}
      </TextField>
    </Box>
  );
}
